export const renameObjectKeys=(object)=>{
    var newObject={};
    Object.keys(object).forEach(x=> {newObject[x[0].toLowerCase()+x.slice(1)] = object[x];});
    return newObject;
}